import React from 'react';
import { Ionicons } from '@expo/vector-icons';

import { useTheme } from '../../theme';
import DesignEmptyState from '../../design/components/EmptyState';

/**
 * Shared empty/error state for lists and screens: icon, message, optional
 * hint line and optional action button. Renders the redesign EmptyState.
 */
const EmptyState = ({
	icon = 'file-tray-outline',
	message,
	hint,
	actionLabel,
	onActionPress,
	style,
}) => {
	const { theme: { ui: { colors } } } = useTheme();

	return (
		<DesignEmptyState
			icon={<Ionicons name={icon} size={34} color={colors.iconMuted} />}
			title={message}
			message={hint}
			actionLabel={actionLabel}
			onAction={onActionPress}
			style={style}
		/>
	);
};

export default EmptyState;
